import { useEffect } from 'react';

import { useJobProspectsStatsActions } from './JobProspectsStatsContext';
import { getUserPipelineDebug } from './restApi';

const UserPipelineDebugLoader = ({ userId }) => {
  const { initializeState, onResponse, onError } = useJobProspectsStatsActions();

  useEffect(() => {
    initializeState();
  }, []);

  useEffect(() => {
    if (userId) {
      getUserPipelineDebug({ userId, onResponse, onError });
    } else {
      getUserPipelineDebug({ onResponse, onError });
    }
  }, []);

  return null;
};

export default UserPipelineDebugLoader;
